<template>
    <div v-if="registration">
        <top-navbar padding="6" :breadcrumb="breadcrumb"></top-navbar>

        <div class="container-fluid mt--6">

            <div class="row">
                <div class="col-12">
                    <header-card
                        :registration="registration"
                        :simulation="simulation"
                        :status-data="statusData"
                        :status-colors="statusColors"
                        :sync="sync"
                    >
                    </header-card>
                    <log-steps
                        current="summary"
                        :registration="registration"
                        :simulation="simulation"
                    ></log-steps>
                    <log-summary
                        :registration="registration"
                        :simulation="simulation"
                        :stats="stats"
                        :sync="sync"
                        @reload="loadStats"
                    ></log-summary>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import HeaderCard from './logs/Header';
    import LogSteps from './logs/LogSteps';
    import LogSummary from './logs/LogSummary';

    export default {

        components: {
            HeaderCard, LogSteps, LogSummary
        },

        data() {
            return {
                registration: null,
                simulation: null,
                stats: null,
                statusData: [],
                statusColors: {},
                sync: null,
            }
        },

        computed: {

            breadcrumb() {
                return [
                    {
                        name: this.$t('common.logs'),
                        route: '/socrates/ui/dashboard/logs'
                    },
                    {
                        name: this.registration.cohort.name + ' / ' + this.registration.degree.name,
                    },
                    {
                        name: this.simulation.name,
                    },
                ]
            },
        },

        beforeRouteEnter(to, from, next) {
            Vue.prototype.$loader.show()
            axios.get('/socrates/api/front/dashboard/page/logs/registrations/' + to.params.registrationId + '/simulations/' + to.params.simulationId + '/log/summary')
            .then(resp => {
                next(vm => {
                    vm.registration = resp.data.included.registration
                    vm.simulation = resp.data.included.simulation
                    vm.statusData = resp.data.included.status_data
                    vm.statusColors = resp.data.included.status_colors
                    vm.$permissions.setRights(resp.data.included.rights)
                    vm.loadStats()
                })
            })
            .catch(err => {
                if (err.response.status == 403) {
                    next({ name: 'unauthorized' });
                } else if (err.response.status == 444) {
                    // This may happen if the connection fails with an online session.
                    next({ name: 'home' });
                }
            });
        },

        methods: {

            loadStats() {
                axios.get('/socrates/api/front/dashboard/data/logs/registrations/' + this.registration.id + '/simulations/' + this.simulation.id + '/stats')
                .then(resp => {
                    this.$loader.hide()
                    this.stats = resp.data.data
                    this.sync = resp.data.included && resp.data.included.sync
                        ? resp.data.included.sync
                        : null
                })
                .catch(err => {
                    this.$auth.handleErrorVm(err, this)
                })        
            },
        }
    }
</script>
